import { render, staticRenderFns } from "./LineText3.vue?vue&type=template&id=796a2617&"
import script from "./LineText3.vue?vue&type=script&lang=js&"
export * from "./LineText3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports